import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockModal', {
  title: 'Bloquear producto o modificador',
  store: 'Seleccionar tienda',
  type: 'Tipo',
  chooseType: 'Seleccionar un tipo',
  cancel: 'Cancelar',
  block: 'Bloquear producto',
  name: 'Nombre',
  chooseName: 'Seleccione el producto/ingrediente',
  modifier: 'Seleccionar modificador',
  lock: 'Periodo de bloqueo',
  chooseLock: 'Seleccionar periodo de bloqueo',
  endOfDay: 'Por el resto del día {{endOfDay}}',
  textOrderManager: 'Te recomendamos bloquear este producto también en el portal de {{channel}}.',
  uber_eats: 'Uber Eats',
  order_manager: 'Order Manager',
  rappi: 'Rappi',
  show: 'Mostrar producto bloqueado'
});

i18next.addResources('es_CR', 'BlockModal', {
  title: 'Bloquear producto o modificador',
  store: 'Seleccionar tienda',
  type: 'Tipo',
  chooseType: 'Seleccionar un tipo',
  cancel: 'Cancelar',
  block: 'Bloquear producto',
  name: 'Nombre',
  chooseName: 'Seleccione el producto/ingrediente',
  modifier: 'Seleccionar modificador',
  lock: 'Periodo de bloqueo',
  chooseLock: 'Seleccionar periodo de bloqueo',
  endOfDay: 'Por el resto del día {{endOfDay}}',
  textOrderManager: 'Te recomendamos bloquear este producto también en el portal de {{channel}}.',
  uber_eats: 'Uber Eats',
  order_manager: 'Order Manager',
  rappi: 'Rappi',
  show: 'Mostrar producto bloqueado'
});
